import { TMessage } from "../i18n/tt";
import { useTranslation } from "../stores/RootStoreContext";
import { FgColor, fgColorClassName } from "./colors";

export type BetaLabelProps = {
  label?: TMessage;
  color?: FgColor;
};

export function BetaLabel({ label, color = "info" }: BetaLabelProps) {
  const { t } = useTranslation();
  return (
    <sup className={`tw-font-bold ${fgColorClassName(color)}`}>{label ? t(label) : "Beta"}</sup>
  );
}
